<div class="pg-wrapper">
  <div class="page-not-found__content">
    <div class="grid align-items-center"
      ngClass="{{(deviceValue | async) === DTypes.Mobile || (deviceValue | async) === DTypes.Tablet ? 'flex-column' : ''}}">

      <div class="col-7 col-md-12 col-sm-12 page-not-found__description"
        ngClass="{{(deviceValue | async) === DTypes.Mobile || (deviceValue | async) === DTypes.Tablet ? 'order-1' : ''}}">

        <div class="row"
          ngClass="{{(deviceValue | async) === DTypes.Mobile || (deviceValue | async) === DTypes.Tablet ? 'text-center mt-4' : ''}}">

          <div class="col-12 col-sm-12">
            <h1>Ошибка доступа</h1>
          </div>
        </div>

        <div class="row"
          ngClass="{{(deviceValue | async) === DTypes.Mobile || (deviceValue | async) === DTypes.Tablet ? 'text-center' : ''}}">
          <div class="col-8 col-md-8 col-sm-12"
            ngClass="{{(deviceValue | async) === DTypes.Tablet ? 'margin-auto' : ''}}">

            <p>
              Уважаемый пользователь, запрашиваемая вами страница недоступна, так как у текущей учетной записи нет прав для ее просмотра.
              Попробуйте авторизоваться с другим логином и паролем.
            </p>
          </div>
        </div>

        <div class="row"
          ngClass="{{(deviceValue | async) === DTypes.Mobile || (deviceValue | async) === DTypes.Tablet ? 'text-center' : ''}}">

          <div class="col-4 col-md-7 col-sm-12"
            ngClass="{{(deviceValue | async) === DTypes.Tablet ? 'margin-auto' : ''}}">

            <button class="ui-buttons ui-buttons__blue-large no-shadow" (click)="onSignInLink()">На главную страницу</button>
          </div>
        </div>
      </div>
      <div class="col-5 col-md-12 col-sm-12"
        ngClass="{{(deviceValue | async) === DTypes.Mobile || (deviceValue | async) === DTypes.Tablet ? 'order-0' : ''}}">

        <div class="page-not-found__img" ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-6' : ''}}">
          <img src="assets/images/template/error.png">
        </div>
      </div>
    </div>
  </div>
</div>
